import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Saves one edited markup.
 *
 * **One markup root field** (Markup contract §1): `SingleMarkupRootFieldGuard` answers `VALIDATION`
 * to a document carrying two, because they race the request-scoped Mongo session. The batched
 * `updateMarkups` is deliberately not used here — this epic saves every edit on its own, and the
 * batch's consumer is the autosave engine of the next one (contract Consumption, amendment
 * 2026-09-28).
 *
 * `input` is the contract's `UpdateMarkupInput`: `geometry`, `style` and `text` and nothing else.
 * The anchor, the `type`, the `sequenceNumber`, the author and `imageRef` are immutable, so no
 * spelling of this mutation can change them (§1, KD-20).
 *
 * The selection set is `MARKUP_FIELDS`, shared with `GET_MARKUPS` and `CREATE_MARKUP` (KD-9): the
 * saved row comes back in the same shape a listed one does, which is what lets the store take it as
 * the markup's new last-saved state without a re-read.
 */
export const UPDATE_MARKUP = gql(`
	mutation UpdateMarkup($id: ID!, $input: UpdateMarkupInput!) {
		updateMarkup(id: $id, input: $input) {
			...MarkupFields
		}
	}
`);
